import styled from "styled-components";

export const Button = styled.button`
  width: 70px;
  height: 30px;
  font-size: 12px;
  font-family: Nunito;
  border-radius: 5px;
  border: none;
  cursor: pointer;

  &:hover {
    opacity: 0.7;
  }
`;
